import React, { useEffect, useState, useRef } from 'react';
import { Phone, Instagram, Facebook, Globe, ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
import { Lang } from '../lib/translations';
const languages: {
  code: Lang;
  label: string;
}[] = [{
  code: 'en',
  label: 'English'
}, {
  code: 'fr',
  label: 'Français'
}, {
  code: 'es',
  label: 'Español'
}];
export function TopBar() {
  const {
    currentLang,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const selectedLang = languages.find(l => l.code === currentLang);
  return <div className="fixed top-0 left-0 right-0 z-50 bg-teal-950/90 backdrop-blur-md border-b border-white/10" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-14" data-id="element-140">
        {/* Social & Contact Icons */}
        <div className="flex items-center gap-5" data-id="element-141">
          <a href="tel:+19546559109" aria-label="Call us" className="text-white/70 hover:text-[#D4A843] transition-colors duration-200" data-id="element-142">
            <Phone className="w-6 h-6" data-id="element-143" />
          </a>
          <a href="https://www.instagram.com/cheersbylisa.events?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram" className="hover:opacity-80 transition-opacity duration-200" data-id="element-144">
            <svg width="0" height="0" className="absolute" data-id="element-145">
              <defs data-id="element-146">
                <linearGradient id="ig-grad-top" x1="0%" y1="100%" x2="100%" y2="0%" data-id="element-147">
                  <stop offset="0%" stopColor="#f09433" data-id="element-148" />
                  <stop offset="25%" stopColor="#e6683c" data-id="element-149" />
                  <stop offset="50%" stopColor="#dc2743" data-id="element-150" />
                  <stop offset="75%" stopColor="#cc2366" data-id="element-151" />
                  <stop offset="100%" stopColor="#bc1888" data-id="element-152" />
                </linearGradient>
              </defs>
            </svg>
            <Instagram className="w-6 h-6" style={{
            stroke: 'url(#ig-grad-top)'
          }} data-id="element-153" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61576473615425" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook" className="text-[#1877F2] hover:opacity-80 transition-opacity duration-200" data-id="element-154">
            <Facebook className="w-6 h-6" data-id="element-155" />
          </a>
        </div>

        {/* Language Selector */}
        <div className="relative" ref={dropdownRef} data-id="element-156">
          <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-200 text-base" data-id="element-157">
            <Globe className="w-5 h-5" data-id="element-158" />
            <span className="hidden sm:inline" data-id="element-159">{selectedLang?.label}</span>
            <span className="sm:hidden uppercase" data-id="element-160">{currentLang}</span>
            <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-161" />
          </button>

          {isOpen && <div className="absolute right-0 top-full mt-1 bg-white rounded-md shadow-lg border border-amber-100 overflow-hidden min-w-[140px]" data-id="element-162">
              {languages.map(lang => <button key={lang.code} onClick={() => {
            setLanguage(lang.code);
            setIsOpen(false);
          }} className={`w-full text-left px-4 py-2.5 text-sm transition-colors duration-150 ${currentLang === lang.code ? 'bg-[#D4A843]/10 text-[#D4A843] font-medium' : 'text-zinc-700 hover:bg-[#FFF8F0]'}`} data-id="element-163">
                  {lang.label}
                </button>)}
            </div>}
        </div>
      </div>
    </div>;
}